import { render, staticRenderFns } from "./SecuritySetting.vue?vue&type=template&id=619571e7&scoped=true";
import script from "./SecuritySetting.vue?vue&type=script&lang=js";
export * from "./SecuritySetting.vue?vue&type=script&lang=js";
import style0 from "./SecuritySetting.vue?vue&type=style&index=0&id=619571e7&prod&scoped=true&lang=less";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "619571e7", null);
export default component.exports;